_ = require 'underscore'
Auth = require 'db/auth'
makeErrorEnum = require 'lib/make-error-enum'
ModelCache = require 'db/model-cache'
ModelLoader = require 'db/model-loader'
Plugin = require 'models/plugin'
PluginIO = require 'views/internal/plugins/plugin-io'
PluginIOCache = require 'views/internal/plugins/plugin-io-cache'
PluginHandlerContext = require 'views/internal/plugins/plugin-handler-context'
pluginOptions = require 'views/internal/plugins/plugin-options'
pluginValidators = require 'lib/plugins/plugin-validators'
processCallbacks = require 'views/internal/plugins/plugin-process-callbacks'
Promise = require 'bluebird'
track = require 'debug/track'
xtend = require 'xtend'

PluginRunnerError = makeErrorEnum 'PluginRunner', [
  'NotHandled'
  'InvalidPlugin'
  'Timeout'
]

DEFAULT_TIMEOUT = 5000
ENABLED_PLUGINS_CACHE_MS = 10000

eventualEnabledPlugins = {}

loadAvailablePlugins = (idBoard) ->
  # We might have several PluginRunners make requests at once (e.g. for badges)
  # and we don't want all of them to trigger duplicate requests to loading the
  # plugins from the server.
  if !eventualEnabledPlugins[idBoard]?
    eventualEnabledPlugins[idBoard] = ModelLoader.loadBoardEnabledPlugins(idBoard)

    eventualEnabledPlugins[idBoard]
    .delay(ENABLED_PLUGINS_CACHE_MS)
    .then ->
      delete eventualEnabledPlugins[idBoard]

  eventualEnabledPlugins[idBoard]

loadPlugin = (board, pluginOrId) ->
  Promise.try ->
    if pluginOrId instanceof Plugin
      return pluginOrId

    if !_.isString(pluginOrId)
      throw PluginRunnerError.InvalidPlugin("invalid plugin specifier")

    idPlugin = pluginOrId
    if (existingPlugin = ModelCache.get('Plugin', idPlugin))?
      return existingPlugin

    if !board?
      throw PluginRunnerError.InvalidPlugin("unable to find plugin")

    loadAvailablePlugins(board.id)
    .then ->
      if (existingPlugin = ModelCache.get('Plugin', idPlugin))?
        return existingPlugin

      throw PluginRunnerError.InvalidPlugin("plugin not available to board")

extractPlugins = ({ plugins, plugin, board }) ->
  plugins =
    if plugins?
      plugins
    else if plugin?
      [plugin]
    else if board?
      board.idPluginsEnabled()
    else
      []

  Promise.map plugins, (pluginOrId) =>
    loadPlugin(board, pluginOrId)

extractCommonContext = (options) ->
  baseContext =
    member: Auth.me()
    permissions:
      board: if options?.board?.editable() then 'write' else 'read'
  if (idOrg = options?.board?.hasOrganization())?
    baseContext.organization = idOrg
  if (org = options?.board?.getOrganization())?
    baseContext.permissions.organization = if org?.hasActiveMembership(Auth.me()) then 'write' else 'read'
  if options.card?
    baseContext.permissions.card = if options.card.editable() then 'write' else 'read'
  extendedContext = ['board', 'list', 'card', 'command', 'el']
  xtend baseContext, _.pick(options, extendedContext)

extractCommandOptions = ({ options }) ->
  options

returnFirstOrError = (responses) ->
  if responses.length == 0
    throw PluginRunnerError.NotHandled("no plugin handles this command")
  responses[0]

validateUrls = (obj, idPlugin) ->
  _.each obj, (val, key) ->
    if _.isObject(val) || _.isArray(val)
      validateUrls(val, idPlugin)
    else if key == 'url' && !pluginValidators.isValidUrlForImage(val)
      console?.warn("Invalid URL detected in Power-Up response for: #{idPlugin}")
      throw new PluginIO.Error.NotHandled("Invalid url")

class PluginRunner
  Error: PluginRunnerError
  processCallbacks: (obj, pluginEntry, baseOptions) ->
    processCallbacks obj, (runOptions) =>
      options = xtend baseOptions, runOptions
      @_run [pluginEntry], extractCommonContext(options), extractCommandOptions(options)
      .then(returnFirstOrError)
      .catch PluginRunnerError.NotHandled, (err) ->
        throw PluginRunnerError.NotHandled("attempt to run callback on plugin #{ pluginEntry.plugin.id } (#{ pluginEntry.io.getName() }) failed")

  _run: (pluginEntries, commonContext, commandOptions, timeout = DEFAULT_TIMEOUT) ->
    { command, board, card, member } = commonContext

    Promise.using PluginHandlerContext.serialize(commonContext), (serializedCommonContext) =>
      Promise.filter pluginEntries, ({ io }) ->
        io.supports(command)
      .map (pluginEntry) =>
        { plugin, io } = pluginEntry

        # We don't currently have any plugin specific context, but we could add
        # some serialized context with PluginHandlerContext.extend if we did
        commandOptionsWithContext = xtend commandOptions,
          context: serializedCommonContext

        io.request command, pluginOptions(commandOptionsWithContext), timeout
        .then (response) =>
          validateUrls(response, plugin.id)
          return {
            response: @processCallbacks response, pluginEntry, { board, card, member }
            idPlugin: plugin.id
          }
        .catch PluginIO.Error.NotHandled, PluginIO.Error.Timeout, ->
          null
      .filter (entry) ->
        entry?
      .map ({ response, idPlugin }) ->
        if Array.isArray(response) && response.every(_.isObject)
          _.map(response, (r) -> xtend r, { idPlugin })
        else if _.isObject(response)
          xtend response, { idPlugin }
        else
          response

  _runFromOptions: (options) ->
    plugins = extractPlugins(options)
    commonContext = extractCommonContext(options)
    commandOptions = extractCommandOptions(options)

    Promise.resolve(plugins)
    .map (plugin) ->
      plugin: plugin
      io: PluginIOCache.get(plugin)
    .then (pluginEntries) =>
      @_run(pluginEntries, commonContext, commandOptions, options.timeout)

  all: (options) ->
    @_runFromOptions(options)
    .then(_.flatten)

  one: (options) ->
    @_runFromOptions(options)
    .then(returnFirstOrError)

module.exports = new PluginRunner()



// WEBPACK FOOTER //
// ./app/scripts/views/internal/plugins/plugin-runner.coffee